// extracted by mini-css-extract-plugin
export var contentWrap = "splitBlogContent-module--content-wrap--da583";
export var layoutBlog = "splitBlogContent-module--layout-blog--e1676";
export var textblockWrap = "splitBlogContent-module--textblock-wrap--644fb";